import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { round } from '../../util/util';
import '../../style/DataTable.css';

const PlayerStatisticsDataTable = (props) => {
  const setColor = (value) => {
    if (Number(value) >= 600) {
      return 'purple';
    } else if (Number(value) >= 550) {
      return 'red';
    } else if (Number(value) >= 500) {
      return 'green';
    }
    return '';
  };

  const getPlayerStatisticsData = () => {
    let rowData = [];
    let matchDaysLength = 0;
    if (props.playerStatistics.length) {
      matchDaysLength = props.playerStatistics[0].gamePinsTotalByRound.length;
    }
    props.playerStatistics.sort(
      (first, second) =>
        second.gamePinsTotalAverage - first.gamePinsTotalAverage
    );

    props.playerStatistics.forEach(function (row, index) {
      row.row_number = index + 1;
    });

    props.playerStatistics.map((row) => {
      let row_data_var = {
        orderNo: row.row_number,
        name: row.name,
        club: row.clubName,
        gamePinsTotalAverage:
          row.gamePinsTotalAverage !== -1 ? (
            <div
              style={{
                color: setColor(row.gamePinsTotalAverage),
                fontWeight: 800,
              }}
            >
              {round(row.gamePinsTotalAverage, 1)}
            </div>
          ) : (
            ''
          ),
        bestGameTotalPins:
          row.bestGameTotalPins !== -1 ? (
            <div
              style={{
                color: setColor(row.bestGameTotalPins),
                fontWeight: 800,
              }}
            >
              {row.bestGameTotalPins}
            </div>
          ) : (
            ''
          ),
        playedRounds: row.playedRounds,
      };
      for (let i = 0; i < matchDaysLength; i++) {
        row_data_var['round-' + i] = (
          <div style={{ color: setColor(row.gamePinsTotalByRound[i]) }}>
            {row.gamePinsTotalByRound[i]}
          </div>
        );
      }
      rowData.push(row_data_var);
      return rowData;
    });

    if (!rowData.length) {
      rowData = [{ name: '' }];
    }

    let columns = [
      {
        label: 'Jrk. nr',
        field: 'orderNo',
      },
      {
        label: 'Nimi',
        field: 'name',
      },
      {
        label: 'Klubi',
        field: 'club',
      },
      {
        label: 'Keskmine tulemus',
        field: 'gamePinsTotalAverage',
      },
      {
        label: 'Parim',
        field: 'bestGameTotalPins',
      },
    ];

    for (let i = 0; i < matchDaysLength; i++) {
      columns.push({
        label: i + 1,
        field: 'round-' + i,
      });
    }

    columns.push({
      label: 'Arv',
      field: 'playedRounds',
    });

    return {
      columns: columns,
      rows: rowData,
    };
  };
  const tableData = getPlayerStatisticsData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default PlayerStatisticsDataTable;
